import React, { useContext, useEffect, useRef, useState } from "react";
import "./styles";
import { FreteGratisMainContainer } from "./styles";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import FreteGratis from "../FreteGratis/FreteGratis";
import ModalRelativo from "../../ModalRelativo/ModalRelativo";
import EstadosFreteGratis from "../EstadosFreteGratis/EstadosFreteGratis";
import { FreteGratis as FreteGratisType } from "../../../types/FreteGratis";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import Form from "../../Form";
import { BotoesContainer, Titulo } from "../../../styled/Styled";
import { Button } from "../../Button";
import Modal from "../../Modal/Modal";
import FreteGratisListagem from "../FreteGratisListagem/FreteGratisListagem";
import CuponsListagem from "../CuponsListagem/CuponsListagem";
import Cupom from "../Cupom/Cupom";
import Swal from "sweetalert2";
import { permissoesApi } from "../../../hooks/permissoesApi";
import moment from "moment";

interface FreteGratisMainProps {
  mostrarTexto?: boolean;
  apenasPerenes?: boolean;
}

const CuponsMain: React.FC<FreteGratisMainProps> = ({
  mostrarTexto = true,
  apenasPerenes = false,
}) => {
  const { cupons, setCupons } = useContext(ConfiguracoesContext);
  const [modalEstado, setModalEstado] = useState<boolean>(false);
  const [cupom, setCupom] = useState<any>({
    cupom: "",
    desconto: 0,
    ativo: true,
    tipo_desconto: "porcentagem",
    dataExpiracao: null,
    quantidadeUso: null,
    quantidadeLimite: null,
    minimo_sacola: null,
  });



  const { theme } = useTheme();

  const [modalCupom, setModalCupom] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const indexCupom = useRef<number>(-1);

  const handleAdicionarCupom = () => {
  setCupom({
    cupom: "",
    desconto: 0,
    ativo: true,
    tipo_desconto: "porcentagem",
    dataExpiracao: null,
    quantidadeUso: null,
    quantidadeLimite: null,
    minimo_sacola: null,
  });
  setModalCupom(true);
};

  const cancelarEdicaoCupom = () => {
    setModalCupom(false);
  };

  const excluirCupom = () => {
    const copia = [...cupons];
    copia.splice(indexCupom.current, 1);
    setCupons(copia);
    setModalEstado(false);
    setModalCupom(false);
  };

  const edicaoCupom = (index: number) => {
    indexCupom.current = index;
    setCupom(cupons[index]);
    setModalCupom(true);
  };

  return (
    <>
      <Modal
        isOpen={modalCupom}
        setModal={setModalCupom}
        width={"100rem"}
        maxWidth="98vw"
        backdrop={"static"}
        padding="3rem 4rem"
        onUseEffect={() => {
          setFormValid(false);
        }}
      >
        <Form
          id="cupom"
          onSubmit={(e) => {
            e.preventDefault();          
            if (cupons.find((c) => c.cupom === cupom.cupom) && indexCupom.current === -1) {
              Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Cupom já cadastrado",
              });
              return;
            }
            if (cupom.tipo_desconto === "porcentagem" && (cupom.desconto / 100) >= 98) {
                Swal.fire({
                  icon: "warning",
                  title: "Desconto inválido",
                  text: "O desconto não pode ser maior que 98%.",
                });
                return;
            }
            if(cupom.tipo_desconto === "valor" && cupom.desconto === 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Desconto inválido",
                    text: "O desconto precisa ser maior que zero.",
                });
                return;
            }
            if (
              cupom.tipo_desconto === "valor" &&
              (!cupom.minimo_sacola || cupom.minimo_sacola < 1)
            ) {
              Swal.fire({
                icon: "warning",
                title: "Valor mínimo inválido",
                text: "O valor mínimo da sacola deve ser de pelo menos R$1,00.",
              });
              return;
            }
            if (
              cupom.tipo_desconto === "valor" &&
              cupom.minimo_sacola &&
              cupom.desconto > cupom.minimo_sacola
            ) {
              Swal.fire({
                icon: "warning",
                title: "Desconto inválido",
                text: "O desconto não pode ser maior que o valor mínimo da sacola.",
              });
              return;
            }
            if (
              cupom.tipo_desconto === "porcentagem" &&
              cupom.minimo_sacola !== undefined &&
              cupom.minimo_sacola !== null &&
              (isNaN(cupom.minimo_sacola) || cupom.minimo_sacola < 0)
            ) {
              Swal.fire({
                icon: "warning",
                title: "Valor mínimo inválido",
                text: "Se preenchido, o valor mínimo da sacola deve ser um valor válido.",
              });
              return;
            }
            if (
              cupom.dataExpiracao &&
              (!moment(cupom.dataExpiracao).isValid() ||
                moment(cupom.dataExpiracao).isBefore(moment()))
            ) {
              Swal.fire({
                icon: "warning",
                title: "Data inválida",
                text: "Se preenchida, a data de expiração deve ser válida e futura.",
              });
              return;
            }            if (
              cupom.quantidadeLimite !== undefined &&
              cupom.quantidadeLimite !== null &&
              (isNaN(cupom.quantidadeLimite) || !Number.isInteger(cupom.quantidadeLimite) || cupom.quantidadeLimite < 1)
            ) {
              Swal.fire({
                icon: "warning",
                title: "Limite inválido",
                text: "Se preenchido, o limite de uso deve ser um número inteiro maior que zero.",
              });
              return;
            }
          
            const copia = [...cupons];
          
            if (indexCupom.current === -1) {
              copia.push(cupom);
            } else {
              copia[indexCupom.current] = cupom;
            }
            setCupons(copia);
            setModalCupom(false);
          }}
          setFormValid={setFormValid}
        >
          <Titulo theme={theme} className="fonteTitulo">
            {indexCupom.current === -1 ? "Adicionar" : "Editar"} Cupom
          </Titulo>
          <Cupom
            setCupom={setCupom}
            cupom={cupom}
            excluirCupom={excluirCupom}
          />
          <BotoesContainer theme={theme}>
            <div
              className="cancelar fonteTexto"
              onClick={() => {
                cancelarEdicaoCupom();
              }}
            >
              Cancelar
            </div>
            <Button
              title="Adicionar"
              type="submit"
              className={`fonteTexto ${!formValid && "disabled"}`}
            />
          </BotoesContainer>
        </Form>
      </Modal>
      <FreteGratisMainContainer theme={theme}>
        <div className="dropdown">
          <CuponsListagem
            configIn="empresa"
            onEditarCupom={edicaoCupom}
            onNovoCupom={handleAdicionarCupom}
            mostrarTexto={mostrarTexto}
            apenasPerenes={apenasPerenes}
          />
        </div>
        <ModalRelativo
          normalModal={true}
          zIndex={9999}
          width="auto"
          background="none"
          isOpen={modalEstado}
          setIsOpen={setModalEstado}
          titulo={""}
          subtitulo={""}
          center={true}
          botaoCancelar="Cancelar"
          cancelar={true}
          onUseEffect={() => {}}
          onCancel={() => {
            setModalEstado(false);
          }}
        >
          <Cupom
            setCupom={setCupom}
            cupom={cupom}
            excluirCupom={excluirCupom}
          />
        </ModalRelativo>
      </FreteGratisMainContainer>
    </>
  );
};

export default CuponsMain;
